import React, { useEffect } from "react";
import classNames from "classnames";
import ContentEditable from "react-contenteditable";
import { OkColorIcon } from "@/icons/color-icons-new";
import { Cancel2Icon } from "@/icons/primary-icons-new";

export type CaEditableInputProps = {
  className?: string;
  value: string;
  onOk?: (value: string) => Promise<boolean>;
  disabled?: boolean;
};

export function CaEditableInput({ className, value, disabled, onOk }: CaEditableInputProps) {
  const [insideValue, setInsideValue] = React.useState(value);
  const [editable, setEditable] = React.useState(false);
  const editableRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    setInsideValue(value);
  }, [value]);

  return (
    <div className={classNames("font-sans-serif", "flex", "flex-col", className)}>
      <ContentEditable
        innerRef={editableRef}
        defaultValue={value}
        className={`border-2 ${
          editable ? "border-purple" : "border-transparent"
        } w-full pt-3 pb-5 px-2.5 text-sm rounded-sm hover:border-purple  transition hover:transition outline-none`}
        html={insideValue}
        onChange={(e) => {
          setInsideValue(e.target.value);
        }}
        disabled={disabled}
        inputMode='text'
        tagName='div'
        onClick={() => setEditable(true)}
        onPaste={(e) => {
          e.preventDefault();
          const text = e.clipboardData.getData("text");
          document.execCommand("insertText", false, text);
        }}
      />

      {/* Control block */}
      {editable && (
        <div className='flex gap-2.5 mt-2.5'>
          <OkColorIcon
            className='cursor-pointer'
            style={{ width: 20 }}
            onClick={async () => {
              if (onOk) {
                const response = await onOk(insideValue);
                if (response) {
                  setEditable(false);
                }
              }
            }}
          />
          <Cancel2Icon
            className='cursor-pointer'
            style={{ width: 20 }}
            onClick={() => {
              setEditable(false);
              setInsideValue(value);
            }}
          />
        </div>
      )}
    </div>
  );
}

export default CaEditableInput;
